import AbstractSymbol from "./AbstractSymbol";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {number} symbolNum
 * @param {number=} reelX
 * @param {number=} reelY
 * @param {?string=} name
 */
export default function SlotSymbol(symbolNum, reelX, reelY, name) {

    if(typeof reelX === 'undefined') { reelX = -1 };
    if(typeof reelY === 'undefined') { reelY = -1 };

    AbstractSymbol.call(this, symbolNum, reelX, reelY, name);
};

SlotSymbol.prototype = Object.create(AbstractSymbol.prototype);
SlotSymbol.prototype.constructor = SlotSymbol;

//Symbol.translatePos = function(pos) {
//	return pos - 180;
//};

SlotSymbol.prototype.clear = function() {
    this.destroy();
};

/**
 * @param {number} x
 * @param {number} y
 * @override
 * @returns {AbstractSymbol}
 */
SlotSymbol.prototype.init = function(x, y) {
    this.createImg("symbols_atlas", x, y);
    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SlotSymbol.prototype.createSymbol = function() {

    if(this.getTextureName() !== "symbols_atlas") {
        this.setTexture("symbols_atlas");
    }

    this.setFrameName(this.symbolName + "_00000");
    return this;
};

SlotSymbol.prototype.createBlurSymbol = function() {

    if(this.getTextureName() !== "symbols_blur_atlas") {
        this.setTexture("symbols_blur_atlas");
    }

    this.setFrameName(this.symbolName + "_blur");
    return this;
};